import { render } from "@/components/pages/individualWorkSupport/requirement001/Requirement001.html?vue&type=template&id=36a76760&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement001/Requirement001.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement001/Requirement001.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement001/Requirement001.scss?vue&type=style&index=0&id=36a76760&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a76760"]])

export default __exports__